export default function checkIsTicketGroupSoldOut(ticketGroup) {
  if (ticketGroup.capacity === null) return false;

  const activeTicketTypes = ticketGroup.ticketTypes.filter(
    ticketType => ticketType.status !== 'archived',
  );

  return (
    activeTicketTypes.reduce(
      (totalSold, ticketType) => totalSold + (ticketType.quantitySold || 0),
      0,
    ) >= ticketGroup.capacity
  );
}
